import * as React from 'react';
import { Provider } from 'react-redux';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { NewbuildingCallbackWidgetProvider } from '../NewbuildingCallbackWidgetProvider';

import { PageContainer } from '../Page';
import { IApplicationContext } from '../../types/application';
import { TReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.VFC<IApplicationProps> = ({ reduxStore, context }) => {
  const { userAgent } = context.custom;

  return (
    <Provider store={reduxStore}>
      <ApplicationContext.Provider value={context}>
        <MicrofrontendProvider registry={context.microfrontendsRegistry}>
          <NewbuildingCallbackWidgetProvider>
            <PageContainer userAgent={userAgent} />
          </NewbuildingCallbackWidgetProvider>
        </MicrofrontendProvider>
      </ApplicationContext.Provider>
    </Provider>
  );
};
